function parseUserFilters(filters, limit, page, searchFilter) {
  return {
    ...filters,
    searchFilter,
    limit,
    page,
  };
}

export { parseUserFilters };
